<template>
  <div class="shouye">
	<div class="navList">
		<div class="navList-item" v-for="(item,index) in navList" :key="index" @click="handleNav(index)">
			<span :class="navListIndex===index?'navList-item-span':'navList-item-span1'">{{item.categoryName}}</span>
			<span :class="navListIndex===index?'navList-item-xian':'navList-item-xian1'"></span>
		</div>
	</div>
	<!-- 1. 将滚动事件监听器添加到列表容器上 -->
	<div class="list" ref="listContainer" @scroll="handleScroll">
		<div class="list-box">
			<zbList v-for="(item,index) in list" :key="index" :data="item"></zbList>
		</div>
		<kong v-if="isKong"></kong>
	</div>
  </div>
</template>

<script>
import { getLiveList, getLiveCategoryList } from "@/api/zhibo";
import { client } from '../../../common/js/alioss'
import zbList from "../../../components/zbList/zbList.vue"
import kong from "../../../components/kong/kong.vue"
import Cookies from 'js-cookie';
export default {
  components: {
    zbList,
	kong
  },
  data() {
    return {
	  navList:[],
	  navListIndex:0,
      queryParams:{
      	page:1,
      	size:20,
      	categoryId:'',
		keyWord:''
      },
	  list:[],
	  hasMore: true,
	  isLoading: false,
	  isKong:false,
	  stateMonitor:null
    };
  },
  created() {
	
  },
  mounted() {
	sessionStorage.setItem('user', 1);
	this.stateMonitor = setInterval(() => {
      const currentValue = this.$store.state.searchQuery;
    }, 10000);
	this.queryParams.page = 1
    this.getLiveCategoryList()
	this.$store.commit('changeCount', 2);
  },
  beforeDestroy() {
	clearInterval(this.stateMonitor);
	this.$store.commit('changeSearchQuery', null);
  },
  computed:{
	  searchQuery(){
		return this.$store.state.searchQuery
	  }
  },
  watch: {
      searchQuery: {
          handler(newValue, oldValue) {
              // 只有当 newValue 发生实际变化时才执行操作
              if (newValue !== oldValue || oldValue === undefined) { // 增加对首次加载的判断
                  console.log("watch 触发，关键词变为:", newValue);
                  this.queryParams.keyWord = newValue;
                  this.queryParams.page = 1;
                  this.hasMore = true;
  
                  // 2. 在这里获取分类列表，确保分类正确
                  //    这会触发 getLiveList() 并使用新的 keyWord
                  this.getLiveCategoryList(); 
              }
          },
          // 添加 immediate: true 选项，确保组件一加载就根据初始 state 执行一次
          immediate: true
      }
  },
  methods: {
	//直播间分类
	getLiveCategoryList(){
		getLiveCategoryList().then(response => {
		  response.data.unshift({
		  	categoryName:this.$t('all.quanbu'),
		  	id:''
		  })
		  this.navList = response.data
		  this.queryParams.categoryId = response.data[0].id
		  this.getLiveList();
		});
	},
	//选择直播分类
	handleNav(index) {
	    this.navListIndex = index
	    this.queryParams.page = 1;
	    this.queryParams.categoryId = this.navList[index].id;
	    this.hasMore = true;
	    this.getLiveList();
	},
    // 获取直播列表
	async getLiveList() {
	  // 3. 如果正在加载或没有更多数据，则直接返回
	  if (this.isLoading || !this.hasMore) {
		return;
	  }

	  try {
		// 4. 发起请求前，将加载状态设为 true
		this.isLoading = true;

		const response = await getLiveList(this.queryParams);
		const newList = response.rows || [];

		if (this.queryParams.page === 1) {
		  this.list = newList;
		} else {
		  this.list = [...this.list, ...newList];
		}

		const totalPages = Math.ceil((response.total || 0) / this.queryParams.size);
		this.hasMore = this.queryParams.page < totalPages;
        if(response.total == 0){
			this.isKong = true
		}else{
			this.isKong = false
		}
	  } catch (error) {
		console.error("获取直播列表失败:", error);
	  } finally {
		// 5. 请求结束（无论成功或失败），将加载状态恢复为 false
		this.isLoading = false;
	  }
	},

	// 滚动事件处理函数
	handleScroll() {
	  // 同样增加 isLoading 判断，防止在请求期间触发
	  if (this.isLoading || !this.hasMore) {
		return;
	  }

	  const container = this.$refs.listContainer;
	  // 判断滚动条是否到达底部（或接近底部）
	  const isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 50; // 50px的缓冲距离

	  if (isAtBottom) {
		console.log("滚动到底部，触发加载更多");
		this.queryParams.page++;
		this.getLiveList();
	  }
	},
	
  }
};
</script>
<style scoped lang="scss">
	@import "./shouye.css";
</style>


// WEBPACK FOOTER //
// shouye.vue?00edbfc5